import httpService from '@/modules/common/services/httpService';
import gatewayService from '@/modules/common/services/gatewayService';

const apiService = httpService.create(window.pov_config.VUE_APP_API_URL_GATEWAY);
const baseRoute = '/v3/ai/staff_ai_settings';

const getStaffAiSettings = async (staffUid) => {
  try {
    const res = await gatewayService.get(`${baseRoute}/${staffUid}`);
    return res.data;
  } catch (e) {
    console.log(e);
    return { success: false };
  }
};

const updateStaffAiSettings = async (staffUid, payload) => {
  try {
    const res = await gatewayService.put(`${baseRoute}/${staffUid}`, payload);
    return res.data;
  } catch (e) {
    console.log(e);
    return { success: false };
  }
};

const getRecommendations = async (params = { dismissed: false }) => {
  const res = await apiService.get('v3/ai/ai_recommendations', params, undefined, true);
  return res.data.data; // { airecommendations, meta } — callers map what they need
};

const updateRecommendation = async (uid, state = 'dismissed', state_source_type = 'user') => apiService.put(`/v3/ai/ai_recommendations/${uid}`, { status: { state, state_source_type } }, false).catch((error) => {
  throw new Error('Failed to update recommendation', { cause: error });
});

const resolveRecommendationAction = async (actionUid) => apiService.post(`/v3/ai/aiagents/recommendations/actions/${actionUid}/resolve`, {}).catch((error) => {
  throw new Error('Failed to resolve recommendation action', { cause: error });
});

export default {
  getStaffAiSettings,
  updateStaffAiSettings,
  getRecommendations,
  updateRecommendation,
  resolveRecommendationAction,
};
